// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__5b97V","content":"GlobalSearch_content__13Ufc"};